export type EditOperationMode = 'idle' | 'create' | 'delete' | 'reorder' | 'run_move';

export function isOperationLocked(editOpMode: EditOperationMode | undefined, allowedMode: EditOperationMode): boolean {
  if (editOpMode == null) return false;
  return editOpMode !== 'idle' && editOpMode !== allowedMode;
}
